<template>
    <div class="dis-goods-list">
        <!-- Tab切换 -->
        <div class="tab-container hnw-area-center">
            <div class="tab-header">
                <div 
                    class="tab-item" 
                    :class="{ active: activeTab === 'today' }" 
                    @click="switchTab('today')"
                >
                    今日促销
                </div>

                 <div 
                    class="tab-item" 
                    :class="{ active: activeTab === 'monthly' }" 
                    @click="switchTab('monthly')"
                >
                    月度促销
                </div>
                
                <!-- <div 
                    class="tab-item" 
                    :class="{ active: activeTab === 'afterSales' }" 
                    @click="switchTab('afterSales')"
                >
                    售后促销
                </div> -->
                <!-- 1 -->
                <!-- <div class="search-container">
                    <el-input 
                        placeholder="请输入搜索关键词" 
                        v-model="searchKeyword" 
                        @keyup.enter.native="handleSearch"
                        @clear="handleClear"
                        clearable
                    ></el-input>
                    <el-button type="primary" @click="handleSearch">搜索</el-button>
                </div> -->
                
                <div class="search-container">
                    <el-input 
                        v-model="searchKeyword" 
                        placeholder="搜索配件" 
                        clearable
                        @clear="handleClear"
                        size="small"
                        @keyup.enter="handleSearch"
                    >
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        <el-button 
                            slot="append" 
                            type="primary" 
                            size="small" 
                            @click="handleSearch"
                        >搜索</el-button>
                    </el-input>
                </div>
            </div>
            
            <!-- 今日促销内容 -->
            <div v-show="activeTab === 'today'" class="tab-content">
                <!-- 折扣切换按钮 -->
                <div class="discount-filter">
                    <div class="filter-label">折扣：</div>
                    <div class="filter-options">
                        <div 
                            class="filter-option" 
                            :class="{ active: selectedDiscount === null }"
                            @click="selectDiscount(null)"
                        >
                            全部
                        </div>
                        <div 
                            class="filter-option" 
                            :class="{ active: selectedDiscount === discount }"
                            v-for="discount in todayDiscountList" 
                            :key="discount"
                            @click="selectDiscount(discount)"
                        >
                            {{ discount }}折
                        </div>
                    </div>
                </div>
                <div class="goods-list ">
                    <el-row :gutter="8">
                        <el-col :xs="12" :sm="12" :lg="{span: '4-8'}" v-for="(item,index) in todayGoodsList" :key="item.id" class="goods-col">
                            <div v-if="$route.params.type==1" class="dis-good-tips">
                                {{ item.roi*10 }}折
                            </div> 
                            <div class="goods-card" @click="goRecommend(item)">
                                <div class="img-box">
                                    <HnwOssImg :src="item.homeImg||item.goods_image"></HnwOssImg>
                                </div>
                                
                                <div class="card-fot">
                                    <div class="fot-bot-price">
                                        <div class="showPrice blue" v-if="$store.getters.isVisitor">
                                            会员可见
                                        </div>
                                        <div v-else class="showPrice">
                                            <div style="font-size:14px; color:#FF2020; padding-top: 8px;">￥</div>
                                            
                                            <!-- <div class="Price" v-if="$route.params.type==1||$route.params.commonid==8">{{item.goods_marketprice}}</div> -->
                                            <div class="Price" >{{item.goods_price}}</div>
                                            <div class="salePrice" >￥{{item.goodprice1||item.goods_price}}</div> 
                                        </div>
                                    </div>
                                    <div class="fot-top">
                                        <span class="goods-name">{{item.goods_name}}</span>
                                        <div v-if="!$store.getters.isVisitor" class="joinCart" @click.stop="joinCart(item)">
                                            <img src="../../assets/index/shop.png" alt="">
                                        </div>
                                    </div>
                                    <div class="fot-bot">
                                        <div class="fot-right">
                                            <div class="store-name">
                                                {{item.oenaturebrand}}
                                            </div>
                                            <div class="store-oe" :title="item.oecode">
                                                {{item.oecode}}
                                            </div>
                                        </div> 
                                        <div v-if="$store.getters.isVisitor" class="store-inventory">
                                        </div>
                                        <div v-else class="store-inventory">
                                            <span v-if="$store.state.look_inv==1">还剩
                                                <span v-if="$store.state.store_id==1780">{{item.goods_stcids}}</span>
                                                <span v-else>{{item.goods_storage}}</span>
                                            </span>
                                            <span v-else>{{item.goods_storage>0?"有货":"无货"}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            
            <!-- 月度促销内容 -->
            <div v-show="activeTab === 'monthly'" class="tab-content">
                <!-- 品牌和分类筛选 -->
                <div class="filter-container">
                    <div class="filter-row">
                        <div class="filter-label">品牌：</div>
                        <div class="filter-options">
                            <div 
                                class="filter-option" 
                                :class="{ active: selectedBrand === brand.title }"
                                v-for="brand in brandList" 
                                :key="brand.title"
                                @click="selectBrand(brand.title)"
                            >
                                <img :src="require(`../../assets/brand/${brand.title}.png`)" :alt="brand.title">
                            </div>
                        </div>
                    </div>
                    
                    <div class="filter-row" v-if="selectedBrand && categoryList.length > 0">
                        <div class="filter-label">分类：</div>
                        <div class="filter-options">
                            <div 
                                class="filter-option fl-op" 
                                :class="{ 'tex-active': selectedCategory === category.id }"
                                v-for="category in categoryList" 
                                :key="category.id"
                                @click="selectCategory(category.id)"
                            >
                                {{ category.g_production }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="red-notice ">
                    注：相关促销政策可线下咨询各区销售
                </div>
                <!-- 月度促销商品列表 -->
                <div class="new-goods-list">
                    <div class="goods-row" v-for="(item,index) in monthlyGoodsList" :key="index">
                        <div class="goods-card">
                            <div class="goods-left">

                                <div class="goods-name">
                                    {{item.goods_name}}
                                    <!-- 促销标签 -->
                                    <img class="cx-icon" src="../../assets/common/cuxiao.png" v-if="item.isMcx" alt="" srcset="">
                                    <div v-if="item.goods_commend==71" class="dis-good-tips-small">
                                        {{item.roiZ}} 折
                                    </div>
                                    <!-- <div v-if="item.isStopBuy == 1" class="stop-buy-tag">停采</div> -->
                                </div>
                                
                                <div class="letf-top" @click.stop="goRecommend(item)">
                                    <el-descriptions title="">
                                        <el-descriptions-item label="OE号"> 
                                            {{item.oecode}}
                                            <HnwCopy :data="item.oecode" :left="2" :top="-14"></HnwCopy>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="生产编码">{{item.sccode}}
                                            <HnwCopy :data="item.sccode" :left="2" :top="-14"></HnwCopy>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="配件品牌">
                                            <div class="goods-oenaturebrand">
                                                {{item.oenaturebrand}}
                                            </div>
                                        </el-descriptions-item>
                                        <el-descriptions-item label="规格">{{item.spec}}</el-descriptions-item>
                                        <el-descriptions-item label="分类">
                                            {{item.oesort}}
                                        </el-descriptions-item>
                                        <el-descriptions-item label="订货价" contentClassName="goods-price">
                                            <div class="symbol">￥</div>
                                            {{item.goods_price}}
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </div>
                                <el-descriptions title="">
                                    <el-descriptions-item label="车型" contentClassName="goods-vehicletype">
                                        <div :title="item.vehicletype">{{item.vehicletype}}</div>
                                    </el-descriptions-item>
                                </el-descriptions>
                                <div class="left-bottom">
                                    <el-descriptions title="" v-if="!$store.getters.isVisitor">
                                        <el-descriptions-item label="库存" contentClassName="goods-storage">
                                            <template v-if="$store.state.member_id.includes('1780')">
                                                <div class="goods-location"> 
                                                    <div>上海:
                                                        <span v-if="$store.state.look_inv==1">{{item.goods_storage}}</span>
                                                        <span v-else>{{item.goods_storage>0?"有货":"无货"}}</span> 
                                                    </div>
                                                    <div>丹阳:
                                                        <span v-if="$store.state.look_inv==1">{{item.goods_stcids}}</span>
                                                        <span v-else>{{item.goods_stcids>0?"有货":"无货"}}</span> 
                                                    </div>
                                                </div>
                                            </template>
                                            <div v-else>
                                                <span v-if="$store.state.look_inv==1">{{item.goods_storage}}</span>
                                                <span v-else :class="{'disabled-color':item.goods_storage==0}">{{item.goods_storage>0?"有货":"无货"}}</span>
                                                <span class="goods-cangTip">{{item.cangTip}}</span>
                                            </div>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </div>
                            </div>
                            <div class="goods-right">
                                <div class="body-item">
                                    <div class="goods-picture">
                                        <HnwOssImg :src="item.homeImg||item.goods_image" :preview="true" :width="120" :id="item.goods_id"></HnwOssImg>
                                    </div>
                                </div>
                                <div class="goods-handle" v-if="!$store.getters.isVisitor">
                                    <div class="numAd">                        
                                        <el-input-number v-model="item.goods_num" :min="1" size="mini"></el-input-number>
                                    </div>
                                    <div class="btn add-btn" :class="{'ygd-btn':item.goods_storage==0}" @click.stop="joinCart(item)">
                                        {{item.goods_storage>0?'加入购物车':'加入预购单'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 售后促销内容 -->
            <div v-show="activeTab === 'afterSales'" class="tab-content">
                <!-- 折扣切换按钮 -->
                <div class="discount-filter">
                    <div class="filter-label">折扣：</div>
                    <div class="filter-options">
                        <div 
                            class="filter-option" 
                            :class="{ active: selectedDiscount === null }"
                            @click="selectDiscount(null)"
                        >
                            全部
                        </div>
                        <div 
                            class="filter-option" 
                            :class="{ active: selectedDiscount === discount }"
                            v-for="discount in afterSalesDiscountList" 
                            :key="discount"
                            @click="selectDiscount(discount)"
                        >
                            {{ discount }}折
                        </div>
                    </div>
                </div>
                <div class="goods-list saAfter-list">
                    <el-row :gutter="8">
                        <el-col :xs="12" :sm="12" :lg="{span: '4-8'}" v-for="(item,index) in afterSalesGoodsList" :key="index" class="goods-col">
                            <div v-if="$route.params.type==1" class="dis-good-tips">
                                {{ item.roi*10 }}折
                            </div> 
                            <div class="goods-card">
                                <div class="img-box">
                                    <HnwOssImg :src="item.homeImg||item.goods_image"></HnwOssImg>
                                </div>
                                
                                <div class="card-fot">
                                    <div class="fot-bot-price">
                                        <div class="showPrice blue" v-if="$store.getters.isVisitor">
                                            会员可见
                                        </div>
                                        <div v-else class="showPrice">
                                            <div style="font-size:14px; color:#FF2020; padding-top: 8px;">￥</div>
                                            
                                            <div class="Price" >{{item.g_price}}</div>
                                            <div class="salePrice" >￥{{item.g_original_price || item.g_price}}</div> 
                                        </div>
                                    </div>
                                    <div class="fot-top">
                                        <span class="goods-name">{{item.g_name}}</span>
                                    </div>
                                    <div class="fot-bot">
                                        <div class="fot-right">
                                            <div class="store-name">
                                                {{item.g_brand}}
                                            </div>
                                            <div class="store-oe" :title="item.g_oem">
                                                {{item.g_oem}}
                                            </div>
                                        </div> 
                                        <div v-if="$store.getters.isVisitor" class="store-inventory">
                                        </div>
                                        <div v-else class="store-inventory">
                                            <span v-if="$store.state.look_inv==1">还剩 {{item.g_stock}}</span>
                                            <span v-else>{{item.g_stock>0?"有货":"无货"}}</span>
                                        </div>
                                    </div>
                                    <!-- <div class="fot-msg" :title="item.g_oem">
                                        OE:{{ item.g_oem }}
                                    </div>
                                    <div class="fot-msg" :title="item.g_code">
                                        生产编码:{{ item.g_code }}
                                    </div>
                                    <div class="fot-msg" :title="item.g_vehicle">
                                        适配车型:{{ item.g_vehicle }}
                                    </div> -->
                                    
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HnwOssImg from "../../components/hnwOssImg.vue";
import HnwCopy from "../../components/HnwCopy.vue";

export default {
    data(){
        return{
            activeTab: 'today', // 默认显示月度促销
            todayGoodsList: [], // 今日促销商品列表
            originalTodayGoodsList: [], // 原始今日促销商品列表（用于折扣筛选）
            afterSalesGoodsList: [], // 售后促销商品列表
            originalAfterSalesGoodsList: [], // 原始售后促销商品列表（用于折扣筛选）
            monthlyGoodsList: [], // 月度促销商品列表
            brandList: [], // 品牌列表
            categoryList: [], // 分类列表
            selectedBrand: '', // 选中的品牌
            selectedCategory: '', // 选中的分类
            searchKeyword: '', // 搜索关键词
            // 折扣相关数据
            todayDiscountList: [], // 今日促销折扣列表（动态生成）
            afterSalesDiscountList: [], // 售后促销折扣列表（动态生成）
            selectedDiscount: null, // 当前选中的折扣（null表示全部）
        }
    },
    methods:{
        // 切换tab
        switchTab(tab) {
            this.activeTab = tab;
            if (tab === 'monthly' && this.brandList.length === 0) {
                this.getMonthlyBrandList();
            }
            
            // 切换标签后应用折扣筛选
            this.selectDiscount(null);
        },
        
        // 选择品牌
        async selectBrand(brand) {
            this.selectedBrand = brand;
            this.selectedCategory = '';
            this.categoryList = [];
            this.monthlyGoodsList = [];
            
            // 获取选中品牌下的分类
            const brandItem = this.brandList.find(item => item.title === brand);
            if (brandItem) {
                this.categoryList = brandItem.child || [];
                
                // 默认选中第一个分类
                if (this.categoryList.length > 0) {
                    const firstCategory = this.categoryList[0];
                    this.selectedCategory = firstCategory.id;
                    // 自动加载第一个分类的商品列表
                    await this.getMonthlyGoodsList(firstCategory.id);
                }
            }
        },
        
        // 选择分类
        async selectCategory(categoryId) {
            this.selectedCategory = categoryId;
            // 获取该分类下的商品列表
            await this.getMonthlyGoodsList(categoryId);
        },
        
        // 获取月度促销品牌列表
        async getMonthlyBrandList() {
            try {
                const res = await this.$api.getMdisClass();
                if (res && res.length > 0) {
                    this.brandList = res;
                    
                    // 默认选中第一个品牌
                    if (this.brandList.length > 0) {
                        const firstBrand = this.brandList[0];
                        this.selectedBrand = firstBrand.title;
                        this.categoryList = firstBrand.child || [];
                        
                        // 默认选中第一个分类
                        if (this.categoryList.length > 0) {
                            const firstCategory = this.categoryList[0];
                            this.selectedCategory = firstCategory.id;
                            // 加载第一个分类的商品列表
                            await this.getMonthlyGoodsList(firstCategory.id);
                        }
                    }
                }
            } catch (error) {
                console.error('获取月度促销品牌列表失败:', error);
            }
        },
        
        // 获取月度促销商品列表
        async getMonthlyGoodsList(categoryId) {
            try {
                const res = await this.$api.getDisList({
                    type: 9,
                    page: 1,
                    limit: 999,
                    id: categoryId
                });
                
                if (res && res.db && res.db.length > 0) {
                    // 处理商品价格
                    res.db.forEach(goods => {
                        goods.goods_price = this.$handlePrice(goods);
                        // 初始化商品数量
                        this.$set(goods, "goods_num", 1);
                    });
                    
                    // 获取商品图片
                    const goodsIds = res.db.map(item => item.goods_id).join(",");
                    const listImgs = await this.$api.getGoodsListHomeImg({
                        goods_id: goodsIds,
                        goods_type: "折扣首图",
                        shop_id: 1780,
                        store_id: 1780 
                    });
                    
                    // 关联商品图片
                    listImgs.forEach(imgItem => {
                        res.db.forEach(goods => {
                            if (goods.goods_id == imgItem.goods_id) {
                                this.$set(goods, "homeImg", imgItem.url);
                            }
                        });
                    });
                    
                    this.monthlyGoodsList = res.db;
                } else {
                    this.monthlyGoodsList = [];
                }
            } catch (error) {
                console.error('获取月度促销商品列表失败:', error);
                this.monthlyGoodsList = [];
            }
        },
        
        goRecommend(acti){
            acti.preRou = "首页";
            let rou = '/index/goodsinfo';
            acti.disMaxNum = Number(acti.number) || 0;
            localStorage.setItem("hnw-web-item-data", JSON.stringify(acti));
            this.$router.push(rou);
        },
        
        async joinCart(carItem){
            if(this.$isCompany()){
                if(carItem.goods_storage<1){
                    return this.$store.commit('UpDateState',{invDia:true});
                }
                let res = '';
                
                let carMessage = {
                    goods_id: carItem.goods_id,
                    sccode: carItem.sccode,
                    oecode: carItem.oecode,
                    goods_name: carItem.goods_name,
                    goods_price: carItem.goods_price,
                    goods_storage: carItem.goods_storage,
                    goods_num: carItem.goods_num || 1,
                    store_id: carItem.store_id,
                    store_name: carItem.store_name,
                    cart_type: '1',
                };
                
                res = await this.$api.joinCart([carMessage]);
            }
        },
        
        // 搜索功能
        async handleSearch() {
            await this.loadData();
            
        },
        
        // 清空搜索框事件
        async handleClear() {
            // 重新加载原始数据
            await this.loadData();
        },
        
        // 选择折扣
        selectDiscount(discount) {
            this.selectedDiscount = discount;
            
            // 过滤今日促销商品
            if (this.activeTab === 'today' && this.originalTodayGoodsList.length > 0) {
                if (discount === null) {
                    this.todayGoodsList = this.originalTodayGoodsList;
                } else {
                    this.todayGoodsList = this.originalTodayGoodsList.filter(item => {
                        const itemDiscount = item.roi * 10;
                        return itemDiscount === discount;
                    });
                }
            }
            
            // 过滤售后促销商品
            if (this.activeTab === 'afterSales' && this.originalAfterSalesGoodsList.length > 0) {
                if (discount === null) {
                    this.afterSalesGoodsList = this.originalAfterSalesGoodsList;
                } else {
                    this.afterSalesGoodsList = this.originalAfterSalesGoodsList.filter(item => {
                        const itemDiscount = item.roi * 10;
                        return itemDiscount === discount;
                    });
                }
            }

        },
        
        // 重新加载数据
        async loadData() {
            // 加载今日促销数据
            let params = {
                id: this.$route.params.id
            };

            if(this.$route.params.commonid!='all'){
                // params.goods_commend = this.$route.params.commonid;
                params.goods_commend = this.$route.params.commonid;
            }
            
            let res = await this.$api.getDisList({
                type: this.$route.params.type,
                page: 1,
                limit: 999,
                search: this.searchKeyword.trim(),
                ...params,
                
            });
            
            if(res.db && res.db.length>0){
                res.db.forEach(goods=>{
                    goods.goods_price = this.$handlePrice(goods);
                });
                
                let goods_id = res.db.map(item=>item.goods_id).join(",");
                let listimgs = await this.$api.getGoodsListHomeImg({
                    goods_id,
                    goods_type: "折扣首图",
                    shop_id: 1780,
                    store_id: 1780 
                });
                 

                listimgs.forEach(item=>{
                    res.db.forEach(goods=>{
                        if(goods.goods_id==item.goods_id){
                            this.$set(goods,"homeImg",item.url);
                        }
                    });
                });
            }
            
            this.todayGoodsList = res.db;
            this.originalTodayGoodsList = res.db;
            
            // 提取今日促销的唯一折扣值
            if (res.db && res.db.length > 0) {
                const discountSet = new Set();
                res.db.forEach(item => {
                    if (item.roi) {
                        const discount = item.roi * 10;
                        if (discount > 0) {
                            discountSet.add(discount);
                        }
                    }
                });
                this.todayDiscountList = Array.from(discountSet).sort((a, b) => b - a); // 降序排序
            } else {
                this.todayDiscountList = [];
            }
        },
        
        // 获取售后促销商品列表
        async getAfterSalesGoodsList() {
            try {
                // 第一个接口获取初始数据
                let allRes = await this.$api.getDisList({
                    type: 1,
                    page: 1,
                    limit: 6
                });
                
                // 过滤出is_stock==1的商品，提取id并拼接成逗号分隔的字符串
                let ids = allRes.filter(item=>item.is_stock==1).map(item=>item.id).join(",");  
               
                // 第二个接口使用上面获取的id参数
                let goodsRes = await this.$api.getOtherDisList({
                    type: 1,
                    page: 1,
                    limit: 6,
                    id: ids
                });
                goodsRes = goodsRes.reverse();
                let goods_id = goodsRes.map(item=>("-1" + item.id)).join(",");
                let listimgs = await this.$api.getGoodsListHomeImg({
                    goods_id,
                    goods_type: "折扣首图",
                    shop_id: 1780,
                    store_id: 1780 
                });
                

                listimgs.forEach(item=>{
                    goodsRes.forEach(goods=>{
                        if(("-1" + goods.id)==item.goods_id){
                            this.$set(goods,"homeImg",item.url);
                        }
                    });
                });
               
                // 将返回的数据赋值给afterSalesGoodsList
                this.afterSalesGoodsList = goodsRes || [];
                this.originalAfterSalesGoodsList = goodsRes || [];
                
                // 提取售后促销的唯一折扣值
                if (goodsRes && goodsRes.length > 0) {
                    const discountSet = new Set();
                    goodsRes.forEach(item => {
                        if (item.roi) {
                            const discount = item.roi * 10;
                            if (discount > 0) {
                                discountSet.add(discount);
                            }
                        }
                    });
                    this.afterSalesDiscountList = Array.from(discountSet).sort((a, b) => b - a); // 降序排序
                } else {
                    this.afterSalesDiscountList = [];
                }
            } catch (error) {
                console.error('获取售后促销商品列表失败:', error);
                this.afterSalesGoodsList = [];
            }
        },
    },
    async created(){
        // 加载初始数据
        await this.loadData();
        // 获取售后促销商品数据
        // await this.getAfterSalesGoodsList();
        // 如果默认是月度促销，加载月度促销数据
        if(this.activeTab === 'monthly') {
            await this.getMonthlyBrandList();
        }
        
    },
    components:{
        HnwOssImg,
        HnwCopy
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.dis-goods-list{
    padding: 10px 0;
    background: #F7F7F7;
    
    .tab-container {
        .tab-header {
            display: flex;
            background: #fff;
            border-bottom: 1px solid #e4e4e4;
            padding: 0 30px;
            .tab-item {
                padding: 12px 0;
                margin-right: 30px;
                cursor: pointer;
                font-size: 16px;
                color: #666;
                border-bottom: 2px solid transparent;
                &.active {
                    color: #3E84D6;
                    border-bottom: 2px solid #3E84D6;
                    font-weight: bold;
                }
            }
            
            .search-container {
                margin-left: auto;
                display: flex;
                align-items: center;
                
              
                .el-input{
                    width: 320px;
                }
                
                .el-input__prefix{
                    left: 10px;
                }
                
                .el-input__append{
                    padding-right: 5px;
                }
                
                .el-button{
                    padding: 0 12px;
                    font-size: 14px;
                }
            }
        }
        
        .tab-content {
            padding: 8px 0;
        }
    }
    
    .filter-container {
        background: #fff;
        padding: 5px 30px;
        // margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        
        .filter-row {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            
            &:last-child {
                margin-bottom: 0;
            }
            
            .filter-label {
                width: 60px;
                font-size: 14px;
                color: #333;
                font-weight: bold;
            }
            
            .filter-options {
                    flex: 1;
                    display: flex;
                    flex-wrap: wrap;
                    
                    .filter-option {
                        
                        padding: 5px ;
                        margin-right: 8px;
                        // margin-bottom: 15px;
                        
                        border-radius: 4px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                        border: 1px solid transparent;
                        
                        
                        
                        &.active {
                            
                            border-color: #3E84D6;
                        }
                        &.tex-active {
                            color: #3E84D6;
                        }
                        
                        img {
                            width: 80px;
                            // max-width: 100%;
                            // max-height: 100%;
                        }
                    }
                    .fl-op{
                        height: 25px;
                        line-height: 25px;
                    }
                }
        }
    }
    
    .discount-filter {
        background: #fff;
        padding: 10px 30px;
        margin-bottom: 10px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        
        .filter-label {
            width: 60px;
            font-size: 14px;
            color: #333;
            font-weight: bold;
        }
        
        .filter-options {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            
            .filter-option {
                padding: 5px 15px;
                margin-right: 10px;
                
                // margin-bottom: 10px;
                border: 1px solid #e4e4e4;
                border-radius: 15px;
                cursor: pointer;
                font-size: 14px;
                color: #666;
                transition: all 0.3s ease;
                
                &:hover {
                    border-color: #3E84D6;
                    color: #3E84D6;
                }
                
                &.active {
                    background: #3E84D6;
                    border-color: #3E84D6;
                    color: #fff;
                }
            }
        }
    }
    .goods-list{
        background: $backGray;
        .el-col-lg-4-8 {
            width: 20%;
        }
        
        .goods-col{
            position: relative;
            
            .dis-good-tips{
                position: absolute;
                right: 4px;
                top: 10px;
                background: url(../../assets/newHome/折扣.png);
                width: 64px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                z-index: 99;
            }
            
            .goods-card{
                background: #fff;
                cursor: pointer;
                height: 336px;
                display: flex;
                margin-bottom: 10px;
                flex-direction: column;
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                border-radius: 6px;
                
                .img-box{
                    height: 210px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    
                    img{
                        width: 210px;
                        height: 210px;
                    }
                }
                
                .card-fot{
                    padding: 0px 14px 10px;
                    box-sizing: border-box;
                    
                    .fot-bot-price{
                        font-size: 18px;
                        padding-right: 10px;
                        
                        .dot{
                            font-size: 14px;
                            position: relative;
                            left: -3px;
                        }
                        
                        .blue{
                            font-size: 14px;
                            color: #3E84D6;
                        }
                        
                        .showPrice{
                            display: flex;
                            margin: 20px 0 10px 0;
                            
                            .Price{
                                font-size: 24px;
                                color: #FF2020;
                            }
                            
                            .salePrice{
                                font-size: 14px;
                                text-decoration: line-through;
                                color: #999999;
                                padding-top: 8px;
                                padding-left: 7px;
                            }
                        }
                    }
                    
                    .fot-top{
                        display: flex;
                        height: 22px;
                        position: relative;
                        
                        .store-name{
                            font-size: 12px;
                            border:1px solid #3E84D6;
                            padding: 3px 1px;
                            margin-right: 5px;
                            border-radius: 2px;
                        }
                        
                        .goods-name{
                            font-size: 16px;
                            font-weight: 500;
                            color: #333333;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            width: 179px;
                        }
                        
                        .joinCart{
                            width: 25px;
                            height: 23px;
                            position: absolute;
                            top: 0;
                            right: 0;
                            cursor:pointer;
                            
                            img{
                                width: 25px;
                                height: 23px;
                            }
                        }
                    }
                    
                    .fot-bot{
                        display: flex;
                        justify-content: space-between;
                        padding-top: 6px;
                        height: 28px;
                        line-height: 28px;
                        
                        .fot-right{
                            display: flex;
                            max-width: 150px;
                            
                            .store-name{
                                min-width: 47px;
                                height: 28px;
                                padding: 0 4px;
                                line-height: 28px;
                                text-align: center;
                                background: #3E84D6;
                                font-size: 14px;
                                color: #fff;
                                margin-right: 14px;
                            }
                            
                            .store-oe{
                                max-width: 130px;
                                font-size: 14px;
                                color: #3E84D6;
                                overflow:hidden;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                            }
                        }
                        
                        .store-inventory{
                            font-size: 14px;
                            color: #999999;
                        }
                    }
                }
            }
        }
    }
    .saAfter-list{
        .goods-card{
            // height: 400px !important;
            // .fot-msg{
            //     height: 20px;
            //     line-height: 20px;
            //     overflow: hidden;
            //     text-overflow: ellipsis;
            //     white-space: nowrap;
            // }
        }
    }
    .red-notice{
        color: red;
        padding: 10px 0;
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #E90101;
    }
    .new-goods-list{
        background: #fff;
        
        .goods-row{
            border-bottom: 1px solid  #E7E7E7;;
            padding: 5px 30px;
            box-sizing: border-box;
            /* 停采标签样式 */
            .stop-buy-tag {
                background-color: #F56C6C;
                color: white;
                font-size: 12px;
                padding: 2px 6px;
                border-radius: 10px;
                z-index: 100;
                margin-left: 8px;
                line-height: 1;
            }
            .goods-name{
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                line-height: 24px;
                padding: 10px 0;
                display: flex;
                align-items: center;

                .tag-icon {
                    display: flex;
                    align-items: center;
                    // transform: scale(0.7);
                    justify-content: center;
                    width: 20px;
                    height: 20px;
                    background: $vin-blue;
                    color: #fff;
                    border-radius: 50%;
                    font-size: 12px;
                    margin-left: 8px;
                }
                .cx-icon{
                    width: 22px;
                    margin-left: 8px;
                }
                // 8折标识样式（小一点的版本）
                .dis-good-tips-small {
                    margin-left: 8px;
                    background: url(../../assets/newHome/折扣.png);
                    background-size: 40px 20px;
                    width: 40px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    font-size: 12px;
                    color: #FFFFFF;
                    z-index: 99;
                }
                .dis-good-tips-small-m{
                    width: 60px;
                    background-size: 60px 20px;
                }
                .share-btn{
                    cursor: pointer;
                    margin-left: 10px;
                    img{
                        width: 20px;
                        position: relative;
                        top: 3px;
                    }
                }
            }
            
            .goods-card{
                display: flex;
                position: relative;
                
                .el-descriptions{
                    .el-descriptions-item__container{
                        align-items: center;
                    }
                    .el-descriptions-item{
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 1;
                    }
                }
                
                .goods-left{
                    flex: 1;
                    position: relative;
                    overflow: hidden;
                    
                    .letf-top{
                        cursor: pointer;
                        .goods-price{
                            color: #F94F4C;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            font-size: 18px;
                            position: relative;
                        }
                    }
                    
                    .goods-oenaturebrand{
                        border-radius: 4px;
                        color: #0D347F;
                        font-size: 12px;
                        min-width: 40px;
                        height: 18px;
                        max-width: 140px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: normal;
                        line-height: 18px;
                        text-align: center;
                        font-weight: 700;
                        font-size: 18px;
                    }
                    
                    .goods-storage{
                        span{
                            font-weight: 700;
                            color: #333;
                            font-size: 16px;
                        }
                        .disabled-color{
                            color: #999;
                            font-weight: 400;
                            font-size: 14px;
                        }
                        .goods-cangTip{
                            color: #F94F4C;
                            font-size: 12px;
                            margin-left: 5px;
                            font-weight: bold;
                        }
                        .goods-location{
                            display: flex;
                            >div{
                                display: flex;
                                align-items: center;
                                margin-right: 5px;
                            }
                        }
                    }
                    
                    .goods-vehicletype{
                        >div{
                            width: 380px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: normal;
                            height: 14px;
                        }
                    }
                    
                    .left-bottom{
                        position: relative;
                    }
                }
                
                .goods-right{
                    display: flex;
                    align-items: flex-end;
                    justify-content: space-between;
                    width: 290px;
                    padding-bottom: 10px;
                    
                    .body-item{
                        text-align: center;
                        .goods-picture{
                            padding-bottom: 10px;
                        }
                    }
                    
                    .goods-handle{
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: center;
                        
                        .addition {
                            padding-top: 5px;
                            font-size: 14px;
                            color: #999;
                        }
                        
                        .btn{
                            width: 112px;
                            height: 34px;
                            background: rgba(6,51,118,0.1);
                            border-radius: 4px;
                            border: 1px solid #063376;
                            color: #063376;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            font-size: 16px;
                            text-align: center;
                            line-height: 34px;
                            cursor: pointer;
                            margin-top: 10px;
                        }
                        
                        .add-btn{
                            color: #F83431;
                            border: 1px solid #F83431;
                            background: #FEEBEA;
                        }
                    }
                }
            }
        }
    }
}
</style>